import { gql, TypedDocumentNode } from "@apollo/client";

import type { MutationRunKillArgs, Run } from "types/generated";

type FetchRunKillData = { runKill: Pick<Run, "id"> };
export const RUN_KILL: TypedDocumentNode<FetchRunKillData, MutationRunKillArgs> = gql`
  mutation KillRun($stack: ID!, $run: ID!) {
    runKill(stack: $stack, run: $run) {
      id
    }
  }
`;